import { useEffect } from 'react';
import type { MapController } from './MapController.js';
import { useDepthStore } from './depthStore.js';
import { useSeamarkStore } from './seamarkStore.js';
import { useBaseLayerStore, baseAttribution } from './baseLayerStore.js';

/**
 * Keep a map's base chart + overlays in sync with the app-wide layer choices
 * (spec 07 KART). Lives in MapShell so every map — Navigate, Planner, track
 * detail, region picker — renders the same chart; the layer buttons only pick,
 * they don't own the wiring.
 */
export function useMapLayers(controller: MapController | null): void {
  const depthOn = useDepthStore((s) => s.on);
  const seamarkOn = useSeamarkStore((s) => s.on);
  const seamarkAttr = useBaseLayerStore((s) => s.seamark.attribution);
  const baseSource = useBaseLayerStore((s) => s.source);
  const baseAttr = useBaseLayerStore(baseAttribution);
  // The ENC base chart already renders depth areas + soundings, so the separate
  // depth overlay is redundant while it's active (mirrors the button in MapControls).
  const encActive = baseSource === 'enc';

  useEffect(() => {
    controller?.setBaseSource(baseSource, baseAttr);
  }, [controller, baseSource, baseAttr]);

  useEffect(() => {
    controller?.setDepthOverlay(depthOn && !encActive);
  }, [controller, depthOn, encActive]);

  useEffect(() => {
    controller?.setSeamarkOverlay(seamarkOn, seamarkAttr);
  }, [controller, seamarkOn, seamarkAttr]);
}
